import React, { useMemo } from 'react';
import { InputGroup, InputLeftElement, Input, InputRightElement, IconButton } from '@chakra-ui/react';
import { SearchIcon, CloseIcon } from '@chakra-ui/icons';

export default function SearchInput({ value, onChange, placeholder = 'Search…', onClear, size, ...props }) {
  const showClear = useMemo(() => Boolean(value && value.length > 0), [value]);
  return (
    // `size` (and any layout prop like flex/maxW a caller passes) goes on
    // InputGroup, not the inner Input - Chakra cascades size from the group
    // to InputLeftElement/Input/InputRightElement together, which is what
    // keeps the icon and the input box the same height. Setting size only
    // on the Input (as both TestRunsPage and TestCaseGroupsPage used to)
    // leaves the icon at the InputGroup's default "md" height while the
    // input box itself shrinks - the exact misalignment this fixes.
    <InputGroup maxW={{ base: '100%', md: '260px' }} size={size} {...props}>
      <InputLeftElement pointerEvents="none">
        <SearchIcon color="gray.400" />
      </InputLeftElement>
      <Input
        value={value}
        onChange={e => onChange?.(e.target.value)}
        placeholder={placeholder}
        variant="filled"
        borderRadius="full"
      />
      <InputRightElement>
        {showClear && (
          <IconButton aria-label="Clear search" icon={<CloseIcon boxSize={2.5} />} size="sm" variant="ghost" onClick={onClear} />
        )}
      </InputRightElement>
    </InputGroup>
  );
}


